import { Box, Skeleton, Typography } from '@mui/material'

interface Props {
  value: string
  caption: string
  loading?: boolean
}

export const SummaryStat = ({ value, caption, loading }: Props) => (
  <Box>
    {loading ? (
      <Skeleton width={80} height={44} />
    ) : (
      <Typography variant='h4' fontWeight={700}>
        {value}
      </Typography>
    )}
    <Typography variant='caption' color='text.secondary'>
      {caption}
    </Typography>
  </Box>
)
